import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import React from 'react';

interface CheckboxItemProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const CheckboxItem: React.FC<CheckboxItemProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          color="primary"
          disabled={disabled}
        />
      }
      label={<Typography variant="subtitle2">{label}</Typography>}
    />
  );
};
